import { ExternalLink } from "lucide-react";

import { Link04 } from "@/assets/icons/Link04";
import { Button } from "@/components/button";

export default function ConnectButton({
  content,
  isDisabled,
  onPress,
}: {
  content?: string;
  isDisabled?: boolean;
  onPress: () => void;
}) {
  return (
    <Button
      className="flex flex-row items-center h-10 mt-5 sm:mt-0 ml-3"
      isDisabled={isDisabled}
      onPress={onPress}
      variant="secondary"
    >
      {content ? (
        <>
          <ExternalLink
            className={`${isDisabled ? "text-text-quaternary" : "text-button-secondary-fg"}`}
          />
          <p
            className={`pl-2 text-md font-semibold max-[401px]:hidden ${isDisabled ? "text-text-quaternary" : "text-button-secondary-fg"}`}
          >
            {content}
          </p>
        </>
      ) : (
        <>
          <Link04
            className={`${isDisabled ? "text-text-quaternary" : "text-button-secondary-fg"}`}
          />
          <p
            className={`pl-2 text-md font-semibold max-[401px]:hidden ${isDisabled ? "text-text-quaternary" : "text-button-secondary-fg"}`}
          >
            Connect
          </p>
        </>
      )}
    </Button>
  );
}
